export default "__VITE_ASSET__B$TWp8lW__"